import routes from '../routes/index.routes';
import { KeysManagement } from '../../pages/keys-management/index/keys-management.page';

export const KeysManagementRouter = [
	{
		path: routes.keysManagement.index(),
		element: <KeysManagement />,
	},
];
